import styled, { css } from 'styled-components';
import { statusTokens } from '../../tokens/components/Status/tokens';

export const statusVariants = {
  'feedback-neutral': statusTokens.GraphicBackgroundColorNeutralDefault,
  'feedback-positive': statusTokens.GraphicBackgroundColorPositiveDefault,
  'feedback-negative': statusTokens.GraphicBackgroundColorNegativeDefault,
  'feedback-notice': statusTokens.GraphicBackgroundColorNoticeDefault,
  'feedback-pending': statusTokens.GraphicBackgroundColorPendingDefault,
};

const statusColors = {
  gray: statusTokens.GraphicBackgroundColorGrayDefault,
  'gray-darker': statusTokens.GraphicBackgroundColorGrayDarkerDefault,
  'blue-lightest': statusTokens.GraphicBackgroundColorBlueLightestDefault,
  'blue-light': statusTokens.GraphicBackgroundColorBlueLightDefault,
  blue: statusTokens.GraphicBackgroundColorBlueDefault,
  'green-lightest': statusTokens.GraphicBackgroundColorGreenLightestDefault,
  green: statusTokens.GraphicBackgroundColorGreenDefault,
  slate: statusTokens.GraphicBackgroundColorSlateDefault,
  red: statusTokens.GraphicBackgroundColorRedDefault,
  yellow: statusTokens.GraphicBackgroundColorYellowDefault,
  orange: statusTokens.GraphicBackgroundColorOrangeDefault,
  white: statusTokens.GraphicBackgroundColorWhiteDefault,
};

/* @internal */
export const StatusLabel = styled.span`
  margin-left: 0.75rem;
`;

/* @internal */
export const MiniStatus = styled.div`
  border-radius: ${statusTokens.GraphicBorderRadiusBaseDefault};
  bottom: 1px;
  height: ${statusTokens.GraphicSizeMiniDefault};
  min-width: ${statusTokens.GraphicSizeMiniDefault};
  position: relative;
  width: ${statusTokens.GraphicSizeMiniDefault};

  ${({ theme }) =>
    theme.statusCell &&
    css`
      left: -14px;
      position: absolute;
      align-self: center;
      bottom: unset;

      ~ ${StatusLabel} {
        margin-left: 0;
        white-space: nowrap;
      }
    `}

  ${({ theme }) =>
    theme.statusColor
      ? css`
          background: ${statusColors[theme.statusColor]};

          ${theme.statusInverse &&
          css`
            background: ${statusTokens.GraphicBackgroundColorInverseDefault};
            border-width: ${statusTokens.GraphicBorderWidthBaseDefault};
            border-style: ${statusTokens.GraphicBorderStyleInverseDefault};
            border-color: ${statusColors[theme.statusColor]};
          `}
        `
      : css`
          background: ${statusVariants[theme.statusVariant]};
        `}

  ${({ theme }) =>
    theme.statusDashed &&
    css`
      background: ${statusTokens.GraphicBackgroundColorDashedDefault};
      border-width: ${statusTokens.GraphicBorderWidthBaseDefault};
      border-style: ${statusTokens.GraphicBorderStyleDashedDefault};
      border-color: ${statusColors[theme.statusColor]};
    `}
`;

/* @internal */
export const StatusInfo = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  padding-left: ${statusTokens.ContentSpacingLeftBaseDefault};

  &:only-child {
    padding-left: 0;
  }
`;

/* @internal */
export const OrnamentWrapper = styled.div`
  ${({ theme }) =>
    theme.statusHasSecondaryText &&
    css`
      margin-top: 5px;
    `}
`;

/* @internal */
export const StyledStatus = styled.div`
  display: inline-flex;
  position: relative;

  ${({ theme }) =>
    theme.statusCell &&
    !theme.statusMini &&
    css`
      // vertical-align is required for good alignment within cell.
      // The value -6px means “align 6px below baseline”
      // Read this PR in full before modifying:
      // https://github.com/carta/ink/pull/4173
      vertical-align: -6px;
    `}

  ${({ theme }) =>
    theme.statusMini &&
    css`
      // align-items is for internal alignment,
      // while vertical-align is for external alignment
      align-items: baseline;
      vertical-align: baseline;
    `}
`;
